/**
 * Top-level keys from a list API payload that should flow through `loadData` →
 * `useEntityTableLoader` → `listResponse` (e.g. GenericTable Table View → $).
 */
export function extractListLevelDollarUnderscoreProps(obj: unknown): Record<string, unknown> {
    if (!obj || typeof obj !== 'object') return {};
    return Object.fromEntries(
        Object.entries(obj as Record<string, unknown>).filter(([k]) => k.startsWith('$') || k.startsWith('_'))
    );
}
